import Pristine from 'pristinejs';


const handleValidation = (form) => {
  
    const pristine = new Pristine(form, {}, false);
   
    let url = $('.mul-dc-charity-amount-btn.active').attr('data-url');
    
    $('button.mul-dc-charity-amount-btn').each(function () {
        
        var btn = $(this);
        console.log('btn', btn)
        btn.click(function(event) {
            $('button.mul-dc-charity-amount-btn').each(function () {
                $(this).removeClass('active')
            });
            console.log('clicked', btn.attr("data-url"))
            event.preventDefault();
            url = btn.attr("data-url");
            btn.toggleClass('active')
            console.log('url', url)
        });
    });
    
    form.addEventListener('submit', (e) => {
        console.log('form is', form)
        
        e.preventDefault()
   
        
        if (pristine.validate()) {
          
          fetch('https://mcc-61ny33y0xgffs2qpr4mbpy28.pub.sfmc-content.com/4v2hzlbfpy3', {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              Accept: 'text/html, *.*',
            },
            body: new FormData(form)
          })
            .then((response) => {
              console.log('response', response)   
            })
            .then(location.assign(url))
            .catch(console.log('error'));

        } else {
          console.log('not valid')
          //cntButton.setAttribute('disabled', true);
          return false;
        }
      });
}


export const initFelix2021 = () => {
    
    var formSection = !!document.getElementById('main')
    if(formSection) {
        console.log('form section', formSection)
        
        
        const form = document.getElementById('main');
        handleValidation(form);
    }
};